import { CommonBusinessObject, PossibleBusinessObject } from '@iotv/iotv-v3-types'
import { UserAttributeDefs } from '../../types/ModelTypes'
import { Address } from '../commonAttributeSets/Address'
import { DefaultContactDetails } from '../commonAttributeSets/DefaultContactDetails'
import { GeoModelCommon } from './GeoModelCommon'
import { enumerable } from '../constructs/enumerableDecorator'
const debug = !process.env.AWS_SESSION_TOKEN && false

const typeName = 'Location'

export class Location extends GeoModelCommon {
  constructor(ob: CommonBusinessObject) {
    super({ ...ob, type: ob.type ?? typeName })
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      ...Address,
      ...DefaultContactDetails,
    }
  }

  @enumerable(false)
  getGeoCodeableAddress = () =>
    Object.keys(Address)
      .map((key) => this[key])
      .filter((entry) => entry)
      .join(',')
}
